export default __webpack_public_path__ + "static/font-bf7a81d2e0f92634933815f92fa6dbd2.woff";